
export class TenantDto {
    id!:string;
    name!:string;
    displayName!:string;
    isConfirmed!: boolean;
    scopeName!:string;
    frontendUrl!:string;
    systemType!:string;
    wpApiKeyInbound!:string;
    wpServerUrl!:string;
    wpApiUser!:string;
    wpApiKey!:string;
    wpTenant!:string;
    maxUserCount!:number;
    maxProjectCount!:number;
    invitationValidForDays!:number;
    additionalModules!:string;
    isForSystemTest!:boolean;
    image!: any[];
    kiToken!:string;
}

export class TenantToCreate{
    id!:string;
    name!:string;
    displayName!:string;
    isConfirmed!: boolean;
    scopeName!:string;
    frontendUrl!:string;
    systemType!:string;
    wpApiKeyInbound!:string;
    wpServerUrl!:string;
    wpApiUser!:string;
    wpApiKey!:string;
    wpTenant!:string;
    maxUserCount!:number;
    maxProjectCount!:number;
    invitationValidForDays!:number;
    additionalModules!:string;
    isForSystemTest!:boolean;
    image!: any[];
    projectRolePairs!: string[];
    inclTGR!:boolean;
    copyTenant!:string;
}

export class TenantScope
{
    name!:string;
    frontendurl!:string;
    systemtype!:string;
}


export class UserTenantDto {
    id!: string;
    userId!:string;
    tenantId!:string;
    tenantName!:string;
    isConfirmed!: boolean;
    isExpanded!: boolean;
    // Clientseitig, nicht vom Server: es gibt noch keinen Endpunkt, um eine
    // Mandanten-Einladung abzulehnen. "Ablehnen" setzt das nur lokal, damit der
    // Bestaetigungsdialog trotzdem entsperrt wird (siehe confirm-tenant-user.component.ts).
    isRejected?: boolean;
    // Noch keine DB-Spalte fuer die Ablehnungsbegruendung - rein clientseitig,
    // damit sie waehrend dieser Sitzung angezeigt werden kann (siehe
    // confirm-tenant-user.component.ts: ablehnenBestaetigen()). Geht nach einem
    // Neuladen verloren, bis das Backend ein Feld dafuer hat.
    rejectionReason?: string;
    // Noch kein Server-Feld fuer die einladende Person - Platzhalter fuer die
    // Anzeige "Eingeladen von", bis das Backend das liefert.
    invitedByName?: string;
    invitedByEmail?: string;
}

export class SelectTenantDto {
    id!:string;
    name!:string;
    displayName!:string;
    isSelected!: boolean;
}

export class TenantResolved {
    tenantDto!:TenantDto;
    error?:any
}

export class SubTenantDto {
    id!:string;
    tenantId!:string;
    tenantName!:string;
    subName!:string;
    subId!:string;
}

export class TenantGroupRoleDto {
    id!:string;
    name!: string;
    displayName!:string;
    permissions!:string;
}

export class TenantGroupRoleUserDto {
    roleId!:string;
    userId!:string;
    userName!:string;
    name!: string;
}
export class TenantDbVersion {
    tenantName!: string;
    dbVersion!: string;
    requiredDbVersion!: string;
}

export class MainDbVersion {
    dbVersion!: string;
    requiredDbVersion!: string;
}

export interface AvailableModulesItemCount {
    moduleName: string;
    moduleId: string;
    isDefault: boolean;
    isConfigAlwaysVisible: boolean;
    count?: number;
    usedCount?: number;
    isBooked?: boolean;
    isDisabled?: boolean;
}
